<template>
  <div>
    <lazy-component @intersected="initAfdMessage" v-bind:is-intersected="forceIntersect">
      <AFDMessageDescriptionComponent v-if="loaded" :afd-message="afdMessage"/>
    </lazy-component>
    <div v-if="!loaded">
      <Skeleton class="skeleton" :loading="true"
                style="width: 100%; display: inline-block; margin-bottom: 5px;"></Skeleton>
      <Skeleton class="skeleton" :loading="true" style="width: 70%; display: inline-block;"></Skeleton>
    </div>
  </div>
</template>

<script>
import afdMessageApi from "~/api/afd_message";
import { Skeleton } from "vue-loading-skeleton";
import AFDMessageDescriptionComponent from './AFDMessageDescriptionComponent'
import { mapGetters } from 'vuex'

export default {
  name: 'AFDMessageByIdDescriptionComponent',
  props: {
    afdMessageId: {
      type: [String, Number],
      required: true
    }
  },
  components: { AFDMessageDescriptionComponent, Skeleton },
  data () {
    return {
      loaded: false,
      afdMessage: null
    }
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
  },
  created () {
  },
  methods: {
    initAfdMessage () {
      afdMessageApi
          .getById(this.afdMessageId)
          .then(response => this.afdMessage = response.data)
          .finally(() => this.loaded = true)
    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
